export default "__VITE_ASSET__CHIgSvoJ__"